import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'

import Button from '../../../../components/button'
import loader from '../../../../components/loader'
import useTime from '../../../../hooks/use-time'
import AuthStore from '../../../../modules/user/stores/auth-store'
import { H4, S05 } from '../../../../styles/typography'
import getCurrencySymbol from '../../../../utils/currency-symbol'
import computeFee from '../../../../utils/fee'
import { RegisterEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Register = () => {
  const router = useRouter()
  const {
    query: { livdemyId, url, action },
  } = router

  const now = useTime(5000)
  const { loggedIn } = AuthStore.useContainer()
  const [registering, toggleRegistering] = useState(false)

  const {
    data: { type, fee, currency, discount, endTime, classCount, chapters },
    certification: { hasCertification = false } = {},
    certification,
    registration = {},
    loadingRegistration,
    loadCertification,
    loadCertificationFailed,
    loadRegistrationFailed,
    register,
    setRegisterModal,
  } = CourseHomeStore.useContainer()

  useEffect(() => {
    ;(async () => {
      if (action === 'register' && loggedIn) {
        if (type !== 'recorded') {
          await router.push(`/${livdemyId}/course/${url}/register`)
        } else if (registration.status === 'UNREGISTERED') {
          if (!loadCertification) {
            if (hasCertification) {
              ;(async () => {
                setRegisterModal(true)
              })()
            } else {
              ;(async () => {
                toggleRegistering(true)
                await register()
                toggleRegistering(false)
              })()
            }
          }
        } else if (action === 'register' && loggedIn) {
          if (registration.status === 'REGISTERED') {
            await router.push(`/${livdemyId}/course/${url}/payment`)
          }
        }
      }
    })()
  }, [
    action,
    livdemyId,
    loggedIn,
    register,
    registration,
    router,
    type,
    url,
    certification,
    hasCertification,
  ])

  const chapterId = chapters[0]?.id
  const lessonId = chapters[0]?.lessons[0]?.id

  const { original, isDiscounted, final, discountPercentage } = useMemo(
    () => computeFee(type === 'recorded' ? fee : fee / classCount, discount),
    [type, fee, classCount, discount],
  )

  const currencySymbol = useMemo(() => getCurrencySymbol(currency), [currency])

  return now > endTime ||
    registration.status === 'PAID' ||
    registration.billStatus === 'PAID' ? null : (
    <RegisterEl
      hideFee={
        discount === 100 ||
        fee === 0 ||
        registration.isTeacher ||
        (registration.status === 'APPROVED' &&
          registration.billStatus === 'PAID')
      }
    >
      {loader(
        loadingRegistration && loadCertification,
        loadRegistrationFailed && loadCertificationFailed,
        <>
          <div className='fee'>
            {isDiscounted && (
              <S05>
                {currencySymbol} {original}
              </S05>
            )}
            <H4>
              {currencySymbol} {final}
              {type !== 'recorded' ? (
                <span>/ class</span>
              ) : isDiscounted ? (
                <span>({discountPercentage} off)</span>
              ) : null}
            </H4>
          </div>
          {(registration.status === 'APPROVED' &&
            registration.billStatus === 'PAID') ||
          registration.isTeacher ? (
            type === 'recorded' ? (
              // eslint-disable-next-line @next/next/link-passhref
              <Link
                href={`/${livdemyId}/course/${url}/chapter/${chapterId}/lesson/${lessonId}`}
              >
                <Button theme='primary'>Start Watching</Button>
              </Link>
            ) : (
              <Link href={`/${livdemyId}/course/${url}/dashboard`} passHref>
                <a>
                  <Button theme='primary'>Dashboard</Button>
                </a>
              </Link>
            )
          ) : registration.status === 'UNREGISTERED' ||
            !registration?.requires?.approval ? (
            <Button
              disabled={registering}
              onClick={() =>
                type === 'recorded'
                  ? hasCertification
                    ? (async () => {
                        setRegisterModal(true)
                      })()
                    : (async () => {
                        toggleRegistering(true)
                        await register()
                        toggleRegistering(false)
                      })()
                  : router.push(`/${livdemyId}/course/${url}/register`)
              }
              requiresLogin='register'
              theme='primary'
            >
              {registering ? `REGISTERING...` : `REGISTER`}
            </Button>
          ) : registration.status === 'DRAFT' ? (
            <Button disabled onClick={() => {}} theme='primary'>
              Request Sent
            </Button>
          ) : (registration.status === 'APPROVED' &&
              registration.billStatus === 'NOT_PAID') ||
            type === 'recorded' ? (
            <Link href={`/${livdemyId}/course/${url}/payment`} passHref>
              <a>
                <Button theme='primary'>FEE PAYMENT</Button>
              </a>
            </Link>
          ) : null}
        </>,
      )}
    </RegisterEl>
  )
}

export default Register
